/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { PreventiveSheetTemplateService } from './PreventiveSheetTemplateService';

class PreventiveSheetTemplateServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new PreventiveSheetTemplateService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { PreventiveSheetTemplateServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/service/PreventiveSheetTemplateServiceProvider.js